import { render } from "./VendorCreationDialog.vue?vue&type=template&id=bb7c9766"
import script from "./VendorCreationDialog.vue?vue&type=script&lang=js"
export * from "./VendorCreationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__